@if (showField$ | async) {
  <mat-form-field [floatLabel]="field.floatLabel || 'auto'">
    <mat-label>{{(field.label | translate) || ''}}</mat-label>
    <mat-select
      [required]="!!field.validators?.required"
      [multiple]="field.attrs?.multiple"
      [attr.name]="field.name"
      [formControl]="$any(field.control)"
      >
      @for (o of field.options; track o) {
        <mat-option [value]="o.value">
          {{ o.label }}
        </mat-option>
      }
    </mat-select>
    @if (hasDanger() && !isDisabled()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
